import Transformer from './../transformer'

export default class BudgetTransformer extends Transformer {
  // static fetch(budget) {}

  static send({concepts, ...scope}) {
    const { workedDays, avegareMWorkers, avegareOWorkers, avegareFWorkers,
            avegareAWorkers } = scope
    return {
      concepts: concepts.map(concept => ({
        concept: concept.id,
        quantity: Number(concept.realQuantity),
      })),
     real_worked_days: workedDays, 
      average_master_workers: avegareMWorkers,
      average_official_workers: avegareOWorkers,
      average_flag_workers: avegareFWorkers,
      average_assistant_workers: avegareAWorkers,
    }
  }

  static fetch(budget) {
    return { 
      affected: budget.affected,
      clientPrice: budget.client_price,
      realPrice: budget.real_price,
      concepts: budget.concepts.map(c => ({
       ...c,
       quantity_executed: undefined,
       realQuantity: c.quantity_executed,
      }))
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/budget.js